(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.havinbag-card-arrow');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var nav = btn.closest('.havinbag-card-nav');
    var media = btn.closest('.media');
    if (!nav || !media) return;
    var images = nav.dataset.images.split('|');
    if (images.length < 2) return;
    var index = parseInt(nav.dataset.index || '0', 10);
    index = (index + parseInt(btn.dataset.dir, 10) + images.length) % images.length;
    nav.dataset.index = index;
    media.classList.add('havinbag-engaged');
    var img = media.querySelector('img');
    if (img) { img.removeAttribute('srcset'); img.src = images[index]; }
  });
})();
